


























































































































































































import { Vue, Component } from "vue-property-decorator";
import {
	getVipCapabilityStatusLabel,
	getVipCapabilityTypeLabel,
	getVipCertificateStatusLabel,
	getVipCertificateTypeLabel,
	VIPCapability,
	VipCapabilityStatus,
	VipCapabilityType,
	VIPCertificate,
	VipCertificateStatus,
	VipCertificateType,
	getVipCapabilityTypeList,
	getVipCapabilityStatusList,
	getVipCertificateStatusList,
	getVipCertificateTypeList,
	VipProjectStatus,
	VIPProject,
	getVipProjectStatusList,
	getVipProjectStatusLabel,
	toaster,
	getVipCapabilityRequestStatusList,
	getVipCapabilityRequestStatusLabel,
	VipCapabilityRequestStatus,
	VIPCapabilityRequest,
} from "@/loader";
import CapabilityStatusBadge from "./capability/CapabilityStatusBadge.vue";
import CapabilityRequestStatusBadge from "./capability-request/CapabilityRequestStatusBadge.vue";
import CertificateStatusBadge from "./certificate/CertificateStatusBadge.vue";

type EnumDictionary<T extends string | symbol | number, U> = {
	[K in T]: U;
};

@Component({
	components: {
		CapabilityStatusBadge,
		CapabilityRequestStatusBadge,
		CertificateStatusBadge,
	}
})
export default class SidebarHelp extends Vue {
	public capabilities: VIPCapability[] = [];
	public capabilitiesComments: EnumDictionary<VipCapabilityStatus, string> = {
		[VipCapabilityStatus.draft]: "Statut initial d'une capacité, il permet de sélectionner les certificats qui serviront à la valider.",
		[VipCapabilityStatus.sent]: "Lorsque vous avez validé la capacité, vous pouvez la marquer Envoyée pour indiquer que vous êtes en attente de réponse de la FNTP.",
		[VipCapabilityStatus.signed]: "Cet état vous permet d'indiquer que la FNTP vous a accordé la capacité et d'indiquer sa date de fin de validité.",
		[VipCapabilityStatus.refused]: "Cet état vous permet d'indiquer que la FNTP vous a refusé la capacité.",
		[VipCapabilityStatus.expired]: "Cet état sera appliqué automatiquement lorsque la capacité aura expiré.",
		[VipCapabilityStatus.archived]: "Cet état vous permet d'archiver la capacité.",
	};
	public capabilityStatus = getVipCapabilityStatusList();
	public capabilityType = getVipCapabilityTypeList();
	public getVipCapabilityStatusLabel = getVipCapabilityStatusLabel;
	public getVipCapabilityTypeLabel = getVipCapabilityTypeLabel;

	public capabilityRequests: VIPCapabilityRequest[] = [];
	public capabilityRequestsComments: EnumDictionary<VipCapabilityRequestStatus, string> = {
		[VipCapabilityRequestStatus.draft]: "Phase initiale de la demande. Vous pourrez sélectionner les capacités à inclure ainsi que les certificats qui permettront de les valider.",
		[VipCapabilityRequestStatus.sent]: "Une fois la demande complétée et validée, vous pouvez générer le document et la marquer Envoyée.",
		[VipCapabilityRequestStatus.answered]: "Vous avez reçu la réponse de la FNTP, vous pouvez donc marquer la demande comme Répondu et indiquer dans la fenêtre correspondante le statut de chaque capacité ainsi que la date de réponse.",
	};
	public capabilityRequestStatus = getVipCapabilityRequestStatusList();
	public getVipCapabilityRequestStatusLabel = getVipCapabilityRequestStatusLabel;

	public certificates: VIPCertificate[] = [];
	public certificatesComments: EnumDictionary<VipCertificateStatus, string> = {
		[VipCertificateStatus.draft]: "Statut initial d'un certificat, il permet sa saisie par le conducteur de travaux. Une fois la saisie terminée, il peut demander la validation d'un.e administratif.ve.",
		[VipCertificateStatus.checking]: "L'administratif.ve vérifie le certificat et peut au choix demander des modifications (retour au statut brouillon) ou demander la vérification par un.e responsable.",
		[VipCertificateStatus.validating]: "Le.la reponsable vérifie à son tour le certificat et peut soit demander des modifications (retour au statut brouillon) soit demander l'envoi.",
		[VipCertificateStatus.sending]: "Le certificat est en attente d'envoi par le conducteur de travaux, un.e administratif.ve ou un.e responsable.",
		[VipCertificateStatus.awaiting]: "Le certificat a été envoyé et est en attente de la réponse du client.",
		[VipCertificateStatus.signed]: "Le client a renvoyé le certificat signé, vous pourrez l'insérer ainsi que sa date de signature.",
		[VipCertificateStatus.abandonned]: "Le certificat est abandonné, il pourra ensuite être définitivement supprimé par un.e responsable.",
	};
	public certificateStatus = getVipCertificateStatusList();
	public certificateType = getVipCertificateTypeList();
	public getVipCertificateStatusLabel = getVipCertificateStatusLabel;
	public getVipCertificateTypeLabel = getVipCertificateTypeLabel;

	public projects: VIPProject[] = [];
	public projectsComments: EnumDictionary<VipProjectStatus, string> = {
		[VipProjectStatus.bid]: "Phase initiale du projet.",
		[VipProjectStatus.signed]: "Le projet est signé avec le client.",
		[VipProjectStatus.ended]: "Le projet est terminé, les certificats pourront être générés.",
		[VipProjectStatus.archived]: "Le projet est archivé, il pourra être désarchivé par un.e responsable.",
		[VipProjectStatus.cancelled]: "Le projet est annulé, il pourra ensuite être définitivement supprimé par un.e responsable.",
	};
	public projectStatus = getVipProjectStatusList();
	public getVipProjectStatusLabel = getVipProjectStatusLabel;

	public chars = [
		["²", "³", "¼", "½", "¾"],
		["Ø", "±", "≤", "≥", "‰"],
		["À", "Ç", "É", "È", "œ", "Œ"],
	];

	public animations = [
		"",
		"bounce",
		"flash",
		"pulse",
		"rubberBand",
		"shakeX",
		"shakeY",
		"headShake",
		"swing",
		"tada",
		"wobble",
		"jello",
		"heartBeat",
		"backInDown",
		"backInLeft",
		"backInRight",
		"backInUp",
		"backOutDown",
		"backOutLeft",
		"backOutRight",
		"backOutUp",
		"bounceIn",
		"bounceInDown",
		"bounceInLeft",
		"bounceInRight",
		"bounceInUp",
		"bounceOut",
		"bounceOutDown",
		"bounceOutLeft",
		"bounceOutRight",
		"bounceOutUp",
		"fadeIn",
		"fadeInDown",
		"fadeInDownBig",
		"fadeInLeft",
		"fadeInLeftBig",
		"fadeInRight",
		"fadeInRightBig",
		"fadeInUp",
		"fadeInUpBig",
		"fadeInTopLeft",
		"fadeInTopRight",
		"fadeInBottomLeft",
		"fadeInBottomRight",
		"fadeOut",
		"fadeOutDown",
		"fadeOutDownBig",
		"fadeOutLeft",
		"fadeOutLeftBig",
		"fadeOutRight",
		"fadeOutRightBig",
		"fadeOutUp",
		"fadeOutUpBig",
		"fadeOutTopLeft",
		"fadeOutTopRight",
		"fadeOutBottomRight",
		"fadeOutBottomLeft",
		"flip",
		"flipInX",
		"flipInY",
		"flipOutX",
		"flipOutY",
		"lightSpeedInRight",
		"lightSpeedInLeft",
		"lightSpeedOutRight",
		"lightSpeedOutLeft",
		"rotateIn",
		"rotateInDownLeft",
		"rotateInDownRight",
		"rotateInUpLeft",
		"rotateInUpRight",
		"rotateOut",
		"rotateOutDownLeft",
		"rotateOutDownRight",
		"rotateOutUpLeft",
		"rotateOutUpRight",
		"hinge",
		"jackInTheBox",
		"rollIn",
		"rollOut",
		"zoomIn",
		"zoomInDown",
		"zoomInLeft",
		"zoomInRight",
		"zoomInUp",
		"zoomOut",
		"zoomOutDown",
		"zoomOutLeft",
		"zoomOutRight",
		"zoomOutUp",
		"slideInDown",
		"slideInLeft",
		"slideInRight",
		"slideInUp",
		"slideOutDown",
		"slideOutLeft",
		"slideOutRight",
		"slideOutUp",
	];

	public get canCopyToClipboard(): boolean {
		return Boolean(navigator.clipboard?.writeText);
	}

	public get project(): (status: VipProjectStatus) => VIPProject {
		// @ts-ignore `find` may return undefined but all status are generated in `created`
		return (status: VipProjectStatus) => this.projects.find(p => p.status === status);
	}

	public get certificate(): (status: VipCertificateStatus, type: VipCertificateType) => VIPCertificate {
		// @ts-ignore `find` may return undefined but all status x type are generated in `created`
		return (status: VipCertificateStatus, type: VipCertificateType) => this.certificates.find(c => c.status === status && c.type === type);
	}

	public get capability_request(): (status: VipCapabilityRequestStatus) => VIPCapabilityRequest {
		// @ts-ignore `find` may return undefined but all status are generated in `created`
		return (status: VipCapabilityRequestStatus) => this.capabilityRequests.find(p => p.status === status);
	}

	public get capability(): (status: VipCapabilityStatus, type: VipCapabilityType) => VIPCapability {
		// @ts-ignore `find` may return undefined but all status x type are generated in `created`
		return (status: VipCapabilityStatus, type: VipCapabilityType) => this.capabilities.find(c => c.status === status && c.type === type);
	}

	public get project_comment(): (status: VipProjectStatus) => string {
		return (status: VipProjectStatus) => this.projectsComments[status];
	}

	public get certificate_comment(): (status: VipCertificateStatus) => string {
		return (status: VipCertificateStatus) => this.certificatesComments[status];
	}

	public get capability_request_comment(): (status: VipCapabilityRequestStatus) => string {
		return (status: VipCapabilityRequestStatus) => this.capabilityRequestsComments[status];
	}

	public get capability_comment(): (status: VipCapabilityStatus) => string {
		return (status: VipCapabilityStatus) => this.capabilitiesComments[status];
	}

	public copy(text: string) {
		navigator.clipboard.writeText(text).then(() => {
			toaster.toast({ message: `Texte "${text}" copié`, variant: "info" });
		}).catch(() => {
			toaster.toast({ message: `Le texte "${text}" n'a pas pu être copié. Attention, la fonction de copie n'est pas prise en charge sur les anciens navigateurs. Vous devez utiliser au minimum Edge 79, Firefox 63, Chrome 66 ou Safari 13.1 pour pouvoir bénéficier de cette fonctionnalité.`, variant: "warning", noAutoHide: false, autoHideDelay: 5000 });
		});
	}

	public created() {
		this.capabilities = [];
		for (let { value: status } of this.capabilityStatus) {
			for (let { value: type } of this.capabilityType) {
				this.capabilities.push(new VIPCapability({ status, type }));
			}
		}

		this.capabilityRequests = [];
		for (let { value: status } of this.capabilityRequestStatus) {
			this.capabilityRequests.push(new VIPCapabilityRequest({ status }));
		}

		this.certificates = [];
		for (let { value: status } of this.certificateStatus) {
			for (let { value: type } of this.certificateType) {
				this.certificates.push(new VIPCertificate({ status, type }));
			}
		}

		this.projects = [];
		for (let { value: status } of this.projectStatus) {
			this.projects.push(new VIPProject({ status }));
		}
	}
}
